<template>
  <div class="d-flex flex-column flex-grow-1">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="products"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
    ></filtered-data>

    <div class="container-fluid d-flex align-items-center">
      <h2 class="page-heading">Продукты</h2>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
      >
        <el-table-column label="Идентификатор" prop="id"/>
        <el-table-column label="Наименование" prop="name"/>
        <el-table-column label="Подробнее" align="center" width="220">
          <template slot-scope="{row}">
            <router-link
              class="btn btn-sm btn-outline-light"
              :to="`/settings/recipes/products/${row.id}`"
            >
              Подробнее
            </router-link>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Продукты'},
    data () {
      return {
        filtersValue: {},
        data: {},
        loading: false,
        hasMore: true,
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/recipes/products/index.vue